export default "__VITE_ASSET__BjV60b07__"